import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import ProtectedRoute from '../components/ProtectedRoute';

function ResourcesContent() {
  const navigate = useNavigate();

  return (
    <div>
      <NavBar />
      <div style={{ padding: '32px' }}>
        <h1>Resources</h1>
        <p>This page is under construction.</p>
        <button onClick={() => navigate('/dashboard')}>Go to Dashboard</button>
      </div>
    </div>
  );
}

export default function Resources() {
  return (
    <ProtectedRoute>
      <ResourcesContent />
    </ProtectedRoute>
  );
}

